import { Home } from 'lucide-react';
import type { Customer } from '../../types';

interface PipelineCardPropertyProps {
  customer: Customer;
}

/**
 * Property Information section for expanded pipeline cards
 * Displays property type, bedrooms, homeowner status, and installation timing
 */
export function PipelineCardProperty({ customer }: PipelineCardPropertyProps) {
  const additionalData = customer.additionalData;

  // Don't render if no property information exists
  if (
    !additionalData?.property_type &&
    !additionalData?.bedrooms &&
    !additionalData?.homeowner_status &&
    !additionalData?.installation_timing
  ) {
    return null;
  }

  return (
    <div className="space-y-2">
      <div className="text-xs font-medium flex items-center">
        <Home className="h-3.5 w-3.5 mr-1.5 text-primary" />
        Property Information
      </div>
      <div className="p-3 bg-slate-50 dark:bg-slate-800/60 rounded-md text-xs grid grid-cols-2 gap-2 shadow-sm">
        {additionalData?.property_type && (
          <div className="flex items-center">
            <span className="font-medium mr-1 text-slate-500 dark:text-slate-400">
              Type:
            </span>
            <span className="text-slate-700 dark:text-slate-300">
              {additionalData.property_type}
            </span>
          </div>
        )}
        {additionalData?.bedrooms && (
          <div className="flex items-center">
            <span className="font-medium mr-1 text-slate-500 dark:text-slate-400">
              Bedrooms:
            </span>
            <span className="text-slate-700 dark:text-slate-300">
              {additionalData.bedrooms}
            </span>
          </div>
        )}
        {additionalData?.homeowner_status && (
          <div className="flex items-center">
            <span className="font-medium mr-1 text-slate-500 dark:text-slate-400">
              Status:
            </span>
            <span className="text-slate-700 dark:text-slate-300">
              {additionalData.homeowner_status}
            </span>
          </div>
        )}
        {additionalData?.installation_timing && (
          <div className="flex items-center">
            <span className="font-medium mr-1 text-slate-500 dark:text-slate-400">
              Timeline:
            </span>
            <span className="text-slate-700 dark:text-slate-300">
              {additionalData.installation_timing}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
